import { AnyARecord } from 'dns';

export class CashierRequestDTO {
  public nombre: string;
  public trabajaOrdenesPago: boolean;
  public qrExternoId: any;

  constructor(nombre: string, trabajaOrdenesPago: boolean, qrExternoId: any) {
    this.nombre = nombre;
    this.trabajaOrdenesPago = trabajaOrdenesPago;
    this.qrExternoId = trabajaOrdenesPago ? qrExternoId : '';
  }
}
